export enum AchievementStates {
	OPEN = "open",
	UNCLAIMED = "unclaimed",
	CLAIMED = "claimed",
}
